import Mutations from '../../odata/mutations';

export default { ...new Mutations('solutionExchangeRate'), ...new Mutations('solutionExchangeRates') };
